<template>
    <div class="app-container">
      <el-tabs type="border-card" @tab-click="clickTab">
        <el-tab-pane label="血糖检测">
          <component :is="currentView1" :pInfo="pInfo" v-if="update1"></component>
        </el-tab-pane>
        <!-- <el-tab-pane label="血糖检测总览">
          <component :is="currentView2" :pInfo="pInfo" v-if="update2"></component>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </template>
  
  <script>
  import bloodGlucoseList from "./bloodGlucoseList.vue";
  import bloodGlucoseOverview from "./bloodGlucoseOverview.vue";
  
  export default {
    components: {bloodGlucoseList,bloodGlucoseOverview},
    props: {
      pInfo: {
        typeof: Object,
        default: null
      }
    },
    data() {
      return {
        currentView1: "bloodGlucoseList",
        currentView2: "bloodGlucoseOverview",
        update1: true,
        update2: false
      };
    },
    created() {},
    methods:{
      clickTab(targetName){
        console.log(targetName);
        if(targetName.label == "血糖检测总览") {
          this.update1 = false;
          this.update2 = true;
        } else {
          this.update1 = true;
          this.update2 = false;
        }
      }
    }
  };
  </script>
  
  <style>
  </style>
  